import React from "react";
import styled from "styled-components";
import {
  Button,
  Typography,
  TypographyVariant,
} from "../../../components/ui-kit";
import { Check } from "../../../components/icons";

const Wrapper = styled.div`
  background-image: ${(props) => `url(${props.resource})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  background-color: gray;
  height: calc(25rem - 4rem);
  border-radius: 40px;
  padding: 4rem 6rem;
  display: flex;
  align-items: center;
  @media (max-width: 1200px) {
    height: auto;
    padding: 2.5rem 2rem;
    background-position: left;
  }
`;

const Content = styled.div`
  width: 35%;
  @media (max-width: 1200px) {
    width: 100%;
  }
`;
const Label = styled.p`
  font-size: 40px;
  font-weight: bold;
  color: white;
  line-height: 42px;
  margin-bottom: 10px;
`;

const CheckedItems = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
`;

const StyledDescription = styled(Typography)`
  color: #fff;
  margin-left: 10px;
`;

const StyledButton = styled(Button)`
  margin-top: 25px;
`;

const Link = styled.a`
  text-decoration: none;
`;

interface BannerProps {
  bgSrc: string;
  label: string;
  buttonLabel: string;
  buttonSrc?: string;
  checkedItems: Array<{
    text: string;
  }>;
}

const Banner: React.FunctionComponent<BannerProps> = ({
  bgSrc,
  label,
  checkedItems,
  buttonLabel,
  buttonSrc,
}) => (
  <Wrapper resource={bgSrc}>
    <Content>
      <Label>{label}</Label>
      {checkedItems?.map((el) => {
        return (
          <CheckedItems key={el.text}>
            <div>
              <Check />
            </div>
            <StyledDescription variant={TypographyVariant.HEADER4}>
              {el.text}
            </StyledDescription>
          </CheckedItems>
        );
      })}
      <Link href={buttonSrc} target="_blank" rel="noreferrer">
        <StyledButton>{buttonLabel}</StyledButton>
      </Link>
    </Content>
  </Wrapper>
);

export default Banner;
